import { mapActions } from "vuex";
import * as types from "@/store/types";
export default {
  name: "details-in-table",
  components: {},
  props: [],
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    ...mapActions({
      setTransactionDetail:
        types.transactions.actions.ACTION_TRANSACTIONS_DETAIL
    }),
    openDetailTransaction(data) {
      this.setTransactionDetail({
        drawer: data.drawer,
        reference_number: data.reference_number,
        transaction_type: data.transaction_type
      });
    }
  }
};
